import { createMuiTheme } from '@material-ui/core/styles';
import {lightTheme} from '../../../../../../themes';
import { SharedColors } from '@fluentui/theme';

const theme = createMuiTheme();

const materialUI = ({
    table:{
      padding:theme.spacing(2)
    },
    breadcrumb:{
        paddingLeft:theme.spacing(2),
        backgroundColor:lightTheme.palette.neutralLighterAlt
    },
    header:{
        padding: theme.spacing(2),
        backgroundColor:lightTheme.palette.neutralLighterAlt
    },
    accordion:{
      backgroundColor:lightTheme.palette.neutralLighterAlt,
    }
});

  
const fluentUI ={
      fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px',
      },
      fileIconCell: {
        textAlign: 'left',
        selectors: {
          '&:before': {
            content: '.',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0px',
            visibility: 'hidden',
          },
        },
      },
      highlightRow:{
        backgroundColor: '#fff4ce',
        selectors:{
          '&:hover':{backgroundColor:lightTheme.palette.themeLighter}
        }
      },
      tableRow:{
        selectors:{
          '&:hover':{backgroundColor:lightTheme.palette.themeLighter}
        }
      },
      deleteIcon:{
        color:SharedColors.red10,
      },
      inputIcon:{
        color:SharedColors.yellowGreen10
      },
      newIcon:{
        color:SharedColors.yellowGreen10
      },
      modifyIcon:{
        color:SharedColors.orange10
      },
      controlWrapper: {
        width:'100%'
      },
      search:{
        margin: '5px 5px 5px 5px',
      },
      tableWrapper:{
        height: '550px',
        position: 'relative',
        maxHeight: 'inherit'
      }
}

const styles={
    materialUI,
    fluentUI
};


  export default styles;